export const defined = (value, defaultValue) => {
    if (typeof value !== "undefined" && value !== null) {
        return value;
    }
    return defaultValue;
};
const IS_NODE = typeof window === "undefined";
export const DEFAULT_DISPATCH_CUSTOM_EVENT_OPTION = {
    target: IS_NODE ? null : window.document,
    bubble: true,
    canBeCancelled: true,
    detail: undefined,
};
export const dispatchCustomEvent = (eventName, options = DEFAULT_DISPATCH_CUSTOM_EVENT_OPTION) => {
    if (IS_NODE)
        return;
    const customEvent = new CustomEvent(eventName, {
        bubbles: defined(options.bubble, DEFAULT_DISPATCH_CUSTOM_EVENT_OPTION.bubble),
        cancelable: defined(options.canBeCancelled, DEFAULT_DISPATCH_CUSTOM_EVENT_OPTION.canBeCancelled),
        detail: options.detail,
    });
    defined(options.target, DEFAULT_DISPATCH_CUSTOM_EVENT_OPTION.target).dispatchEvent(customEvent);
};
//# sourceMappingURL=dispatchCustomEvent.js.map